export default "__VITE_PUBLIC_ASSET__565b3298__"